var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9473684210526315s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(18.94736842105263 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8947368421052632s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(37.89473684210526 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8421052631578947s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(56.8421052631579 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.7894736842105263s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(75.78947368421052 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.7368421052631579s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(94.73684210526316 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6842105263157895s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(113.6842105263158 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.631578947368421s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(132.6315789473684 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5789473684210527s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(151.57894736842104 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5263157894736842s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(170.52631578947367 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.47368421052631576s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(189.47368421052633 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.42105263157894735s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(208.42105263157896 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3684210526315789s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(227.3684210526316 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3157894736842105s",
    repeatCount: "indefinite"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(246.31578947368422 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.2631578947368421s",
    repeatCount: "indefinite"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(265.2631578947368 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.21052631578947367s",
    repeatCount: "indefinite"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(284.2105263157895 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.15789473684210525s",
    repeatCount: "indefinite"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(303.1578947368421 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.10526315789473684s",
    repeatCount: "indefinite"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(322.10526315789474 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.05263157894736842s",
    repeatCount: "indefinite"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(341.05263157894734 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38.5,
    rx: 1,
    ry: 2.4,
    width: 2,
    height: 5,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.44885077ebdc5fac04cacab8144a40c1.svg";
export { ForwardRef as ReactComponent };